import { createGlobalStyle } from 'styled-components';
import tw from 'twin.macro';
import ChivoRegular from "@/assets/fonts/Chivo-Regular.ttf";
import ChivoSemiBold from "@/assets/fonts/Chivo-SemiBold.ttf";
import ChivoLight from "@/assets/fonts/Chivo-Light.ttf";
import ChivoBold from "@/assets/fonts/Chivo-Bold.ttf";

const GlobalStyles = createGlobalStyle`
@font-face {
      font-family: 'Chivo';
      font-weight: 400;
      src: url(${ChivoRegular}) format('truetype');
    }
      @font-face {
      font-family: 'Chivo';
      font-weight: 500;
      src: url(${ChivoSemiBold}) format('truetype');
    }
    @font-face {
      font-family: 'Chivo';
      font-weight: 200;
      src: url(${ChivoLight}) format('truetype');
    }
    @font-face {
      font-family: 'Chivo';
      font-weight: 600;
      src: url(${ChivoBold}) format('truetype');
    }
  :root {
    font-family: 'Chivo', Helvetica, Arial, sans-serif;
    line-height: 1.5;
    font-weight: 400;

    --tw-gradient-from: rgba(53, 125, 66, 0.4);
    --tw-gradient-to: rgba(53, 125, 66, 0);
    --tw-gradient-via: rgba(53, 125, 66, 0.2);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) 70%, var(--tw-gradient-via) 100%;

    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    ${tw`antialiased m-0`};

    color: ${(props) => props.theme.color.text};
  }

  a {
    ${tw`text-green-700 cursor-pointer`};
    
    :hover {
      ${tw`text-green-800 bg-transparent`};
    }
  }
  
  h1 {
    font-size: 2.6rem;
    font-weight: 600;
    margin-bottom: 1em;
  }
  
  h2 {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 0.2em;
  }
  
  h3 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 1em;
  }
  
  p {
    font-size: 0.95rem;
    margin-bottom: 1em;
  }

  .scrollbar-hidden {
  -webkit-overflow-scrolling: touch;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
}

.scrollbar {
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    @apply w-3
      h-3
      right-px;
  }
  &::-webkit-scrollbar-thumb {
    @apply bg-slate-800/5
      transition-all
      duration-200
      rounded
      cursor-pointer;
  }
  &::-webkit-scrollbar-thumb:hover {
    @apply bg-slate-800/20
      cursor-pointer;
  }
  &::-webkit-scrollbar-track {
    @apply rounded
      bg-slate-800/0;
  }
  &::-webkit-scrollbar-track:hover {
    @apply bg-slate-800/0;
  }
  &::-webkit-scrollbar-button {
    @apply hidden;
  }
}

// Google Maps Autocomplete container
.pac-container {
  position: absolute !important;
  background-color: #fff !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 12px;
  z-index: 999999 !important;
  padding-bottom: 4px;
}

.pac-item {
  font-size: 13px !important;
  padding: 8px 16px !important;
  color: #718095;
  cursor: pointer !important;
  z-index: 999999 !important;
  position: relative !important;
  pointer-events: auto;
}

.pac-item:hover {
  background-color: #f0f0f0 !important;
}

.pac-icon {
  display: none !important;
}

.pac-item-query {
  color: #1e293b !important;
  font-size: 14px !important;
}

// React-rnd resize
.custom-handle-wrapper {
  div {
    bottom: -1rem !important;
    
    ${tw`flex items-center justify-center !h-4 !-bottom-4 text-slate-800/50 rounded-full`};

    &:hover {
      ${tw`text-slate-800`};
    }

    &:before {
      ${tw`content-[''] text-slate-400 w-4 h-0.5 rounded-xl absolute transition bg-slate-800/50`};
      
      &:hover {
        ${tw`bg-slate-800`};
      }
    }

    &:after {
      ${tw`absolute z-0 inset-px rounded-full border border-slate-500/20 bg-slate-500/10 opacity-0 transition-opacity`};
      
      &:hover {
        ${tw`opacity-50`};
      }
      
      &:active {
        ${tw`opacity-100`};
      }
    }
  }
}

`;

export default GlobalStyles;
